// HelplineCard.jsx -- the responsible-gambling help block (#1420). Single job: put the National Problem
// Gambling Helpline one tap away, plus state resources. One source for the number: the block screen,
// the Account sheet and the Results footer all read HELPLINE_TEL from here.
import { JT } from "./jumbotronTokens";
import { openInAppBrowser } from "../../lib/platform";

// NCPG's National Problem Gambling Helpline (call, text or chat, 24/7). NCPG retired 1-800-GAMBLER as
// the national number after 2025-09-29; checked on ncpgambling.org 2026-10-09 (Codex r1 on #1441).
export const HELPLINE_TEL = "tel:18006973738";
export const HELPLINE_LABEL = "1-800-MY-RESET";
export const STATE_HELP_URL = "https://www.ncpgambling.org/help-treatment/";

const shell = { display: "flex", flexDirection: "column", border: `1px solid ${JT.border.mid}`, borderRadius: 12, background: JT.bg.well, overflow: "hidden" };
const callRow = { display: "flex", flexDirection: "column", justifyContent: "center", gap: 2, minHeight: 60, padding: "10px 14px", boxSizing: "border-box", color: JT.text.primary, textDecoration: "none" };
const stateRow = { minHeight: 44, padding: "0 14px", border: "none", borderTop: `1px solid ${JT.border.default}`, background: "transparent", color: JT.text.secondary, font: "inherit", fontSize: 13, fontWeight: 600, textAlign: "left", cursor: "pointer" };

export default function HelplineCard() {
  return (
    <div style={shell}>
      <a href={HELPLINE_TEL} style={callRow}>
        <span style={{ fontSize: 16, fontWeight: 700 }}>Call or text {HELPLINE_LABEL}</span>
        <span style={{ fontSize: 12, color: JT.text.tertiary }}>National Problem Gambling Helpline, 24/7</span>
      </a>
      <button type="button" style={stateRow} onClick={() => openInAppBrowser(STATE_HELP_URL)}>Find help in your state</button>
    </div>
  );
}
